import { type StepperStep } from '@fiverr-private/navigation';

export const STEP_GROUPS_STEPPER_CONFIG: StepperStep[] = [
    { id: 0, label: 'Store Set up' },
    { id: 1, label: 'Shopify integration' },
    { id: 2, label: 'Set up completion' },
    { id: 3, label: 'Store optimization' },
    { id: 4, label: 'Store publishing' },
];
